import { Routes, Route } from "react-router-dom";
import Navigation from "./Pages/Navigation";
import Products from "./Pages/Products";
import About from "./Pages/About/About";
import Services from "./Pages/Services/Services";
import Bookings from "./Pages/Bookings/Bookings";
import ProductDetail from "./Pages/Product/ProductDetail";
import Footer from "./Components/Footer/Footer";
import Cart from "./Pages/Cart/Cart";
import ScrollToTop from "./Components/ScrollToTop";
import "./App.css";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import PasswordProtection from "./Components/PasswordProtection/PasswordProtection";
import { useAuth } from "./context/AuthContext";

const AppContent = () => {
  // const { isAuthenticated } = useAuth();

  // if (!isAuthenticated) {
  //   return <PasswordProtection />;
  // }

  return (
    <div className="App">
      <ScrollToTop />
      <Navigation />
      <div className="nav-spacer" />
      <Routes>
        <Route path="/" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/product/:productId" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
      </Routes>
      <Footer />
    </div>
  );
};

function App() {
  return (
    // <AuthProvider>
    <CartProvider>
      <AppContent />
    </CartProvider>
    // </AuthProvider>
  );
}

export default App;
